import { render, staticRenderFns } from "./LKPublicationsList.vue?vue&type=template&id=fb2d37c0&"
import script from "./LKPublicationsList.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsList.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports